// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1___2120e49821d90b0d552","cls2":"SmallAccountMenuButton-cls2__d8704271ba586c1e210a SmallAccountMenuButton-cls1___2120e49821d90b0d552"};